<div class="row calendar-body">
    <div class="row mx-0 px-0 calendar-date-row py-1 border-right align-items-end">
        <div class="col-lg-7 col-md-12 col-sm-12 col-12">
            <div class="row align-items-end">
                <div class="col-md-6 col-12">
                    <label class="dateHeader col-auto pe-0">{{ 'Admin.start_date' | translate }}:</label>
                    <div class="input-group col-12">
                        <input class="form-control" type="text" name="date" id="date" placeholder="mm/dd/yyyy" [ngModel]="NgbStartDate"
                        (dateSelect)="onDateSelection($event);"
                        ngbDatepicker #date="ngbDatepicker"
                        [dayTemplate]="t"
                        autocomplete="off" readonly
                        [firstDayOfWeek]="7">
                        <ng-template #t let-date let-focused="focused">
                            <span class="custom-day"
                            [class.focused]="focused"
                                    [class.range]="isRange(date)"
                                    [class.faded]="isHovered(date) || isInside(date)"
                                    (mouseenter)="hoveredDate = date"
                                    (mouseleave)="hoveredDate = null">
                                    {{ date.day }}
                                </span>
                            </ng-template>
                        </div>
                </div>
                <div class="col-md-6 col-12">
                    <label class="dateHeader col-auto">{{ 'Admin.end_date' | translate }}:</label>
                    <div class="input-group col-12">
                        <input class="form-control" type="text" name="date" [ngModel]="NgbEndDate" ngbDatepicker readonly>
                        <div class="input-group-append">
                            <button class="btn btn-outline-secondary calendar select-date" type="button" (click)="date.toggle();" [disabled]=""><i class="fa fa-calendar"></i></button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-lg-5 col-md-12 col-sm-12 col-12 pt-2">
            <button class="btn btn-enabled btn-default calNavBtn col-4" (click)="prevWeek()">
                <i class="fa fa-chevron-left" aria-hidden="true"></i>
                {{ 'Shared.previous' | translate }}
            </button>
            <button class="btn btn-default calNavBtn col-4" [ngClass]="{'btn-grey': disableTodayButton, 'btn-enabled': !disableTodayButton}" (click)="getStartRange()" [disabled]="disableTodayButton">
                {{ 'Shared.today' | translate }}
            </button>
            <button class="btn btn-enabled btn-default calNavBtn col-4" (click)="nextWeek()">
                {{ 'Shared.next' | translate }} <i class="fa fa-chevron-right" aria-hidden="true"></i>
            </button>
        </div>
    </div>
    <div class="row mx-0 px-0">
        <div class="col-md-12"*ngIf="events.length">
            <div class="row">
                <div class="col-12 custom-col-calendar border-right" *ngFor="let dateObject of dateObjects; last as isLast">
                        <app-calendar-day class="p-0 m-0" [dateObj]="dateObject" (selectedEvent)="eventSelectChange($event)"></app-calendar-day>
                </div>
            </div>
        </div>
        <div class="col-md-12" *ngIf="!events.length">
            <div class="row">
                <div class="col-12 m-0 p-0 border-right center-align">
                    No Events to Display
                </div>
            </div>
        </div>
    </div>
</div>